import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const fetchBecomeCreatorData = () => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/profiles/become_content_creator_requests`,
  });
};

export default fetchBecomeCreatorData;
